import api from "../../../api";

export const getTransactions = async (filters = {}) => {
  const params = new URLSearchParams();
  if (filters.status) params.append("status", filters.status);
  if (filters.type) params.append("type", filters.type);
  if (filters.search) params.append("search", filters.search);
  if (filters.archived !== undefined && filters.archived !== null && filters.archived !== '') {
    params.append("archived", filters.archived);
  }

  const response = await api.get(`/transactions?${params.toString()}`);
  return response.data;
};

export const getTransactionById = async (id) => {
  const response = await api.get(`/transactions/${id}`);
  return response.data;
};

export const updateTransaction = async (id, data) => {
  const response = await api.patch(`/transactions/${id}`, data);
  return response.data;
};

export const addTransactionFlow = async (id, data) => {
  const response = await api.post(`/transactions/${id}/flows`, data);
  return response.data;
};

export const updateTransactionFlow = async (id, flowId, data) => {
  const response = await api.patch(`/transactions/${id}/flows/${flowId}`, data);
  return response.data;
};

export const deleteTransactionFlow = async (id, flowId) => {
  const response = await api.delete(`/transactions/${id}/flows/${flowId}`);
  return response.data;
};

export const getTransactionsKPIs = async (params = {}) => {
  const response = await api.get("/transactions/kpis", {
    params,
  });

  return response.data;
};